import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Nav from './nav';
import { CgMenuRight } from "react-icons/cg";
import { RxCross2 } from "react-icons/rx";



function Header() {
  const [active, setActive] = useState(false);

  const handleClick = () => {
    setActive(!active);
  };
  const handleNavItemClick = () => {
    setActive(false)
  }
  return (
    <header className='site-header'>
      <div className='custom-container'>
        <div className="site-header__wrap">
          <Link to='/' className='site-header__logo'>
            <span>sharma</span>
          </Link>
          <button className="menu-icons" onClick={handleClick}>
            {active ? <RxCross2 /> : <CgMenuRight />}

          </button>

          <nav className={active ? "navbar" : "navbar active"}>
            <Nav onClick={handleNavItemClick} />
          </nav>
        </div>
      </div>

    </header>
  );
}

export default Header;